var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenUserTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5173 2.50769C11.8173 1.97436 10.9507 1.66602 10.0007 1.66602C7.70065 1.66602 5.83398 3.53268 5.83398 5.83268C5.83398 8.13268 7.70065 9.99935 10.0007 9.99935C12.3007 9.99935 14.1673 8.13268 14.1673 5.83268",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8418 18.3333C2.8418 15.1083 6.05013 12.5 10.0001 12.5C10.8001 12.5 11.5751 12.6083 12.3001 12.8083",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 14.9993C18.3327 15.6243 18.1577 16.216 17.8494 16.716C17.6744 17.016 17.4494 17.2827 17.191 17.4993C16.6077 18.0243 15.841 18.3327 14.9993 18.3327C13.7827 18.3327 12.7243 17.6827 12.1493 16.716C11.841 16.216 11.666 15.6243 11.666 14.9993C11.666 13.9493 12.1493 13.0077 12.916 12.3994C13.491 11.941 14.216 11.666 14.9993 11.666C16.841 11.666 18.3327 13.1577 18.3327 14.9993Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6992 15.0002L14.5242 15.8252L16.2992 14.1836",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenUserTick);
export default __webpack_public_path__ + "static/media/brokenUserTick.2099feff7792ecc75a6c9708f4795869.svg";
export { ForwardRef as ReactComponent };